import { Context, Generic } from '../../api/models'

type LocalData = any

export enum Mode {
  Scan,
  Unscan,
}

export enum Action {
  None,
  Navigate,
  Move,
  Invalid,
  ChangeHandler,
  Found,
  Print,
}

export interface ApplyScan {
  scanned: Generic
  context?: Context
  local?: LocalData
}

export type HandlerCallback = (data: any) => void
